import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './Reset.css';
import Menu from './Menu/Menu';
import Galeria from './Galeria/Galeria';
import GaleriaAbout from './Galeria/Galeria-About';
import GaleriaRest from './Galeria/Galeria-Rest';
import Budowa from './Budowa/Budowa';
import Kontakt from './Kontakt/Kontakt';
import About from './About/About';
import About2 from './About/About2';
import RoomsTemp from './Rooms/RoomsTemp';
import Room from './Rooms/Room';
import Restaurant from './Restaurant/Restaurant'
import './App.css';
import Okolica from './okolica/okolica';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Menu />
          <Route path="/" exact component={About2} />
          <Route path="/o-nas" component={About} />
          <Route path="/budowa" component={Budowa} />
          <Route path="/kontakt" component={Kontakt} />
          <Route path="/pokoje" exact component={RoomsTemp} />
          <Route path="/pokoje/pokoj" exact component={Room} />
          <Route path="/restauracja" exact component={Restaurant} />
          <Route path="/okolica" exact component={Okolica} />
          <Switch>
            <Route path="/o-nas" exact component={GaleriaAbout} />
            <Route path="/restauracja" exact component={GaleriaRest} />
            <Route path="/" component={Galeria} />
          </Switch>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js